<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-3 shape-red shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-12">
                                <h2 class="display-2  text-white">Classification Yard Automation
                                    <span>3Z’s FlexYard process control system</span>
                                </h2>
                                <p class="lead  text-white">is one of our flagship products designed specifically for hump or flat switching classification yards. FlexYard has been built with capabilities superior to past and present competing technology, ensuring safety, reliability, and flexibility at low cost. Enhanced protection logic virtually eliminates the possibility of a cornering incident, a Linux OS provides high availability without being prone to crashes, and modular hardware allows the ability to expand, modify, or replace components with minimal downtime and cost. Innovative, custom features not available in competing products such as HumpAnywherelogic, FlexDraw, FlexVoice, and complete remote accessibility to logs, reports, and diagnostics via web browsers sets FlexYard apart from competing products.</p>
                                <!-- <div class="btn-wrapper">
                                    <base-button tag="a"
                                                 href="https://demos.creative-tim.com/argon-design-system/docs/components/alerts.html"
                                                 class="mb-3 mb-sm-0"
                                                 type="info"
                                                 icon="fa fa-code">
                                        Components
                                    </base-button>
                                    <base-button tag="a"
                                                 href="https://www.creative-tim.com/product/argon-design-system"
                                                 class="mb-3 mb-sm-0"
                                                 type="white"
                                                 icon="ni ni-cloud-download-95">
                                        Download HTML
                                    </base-button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section section-lg pt-lg-0 mt--200">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Functionality</h6>
                                    <ul class="list">
                                        <li>Retarder and Switch Control (pneumatic, electric/hydraulic, skate)</li>
                                        <li>Cut/Car Routing and Tracking</li>
                                        <li>Enhanced Stall and Cornering Protection Logic</li>
                                        <li>Advanced Rolling Resistance Algorithms</li>
                                    </ul>
                                    <div>
                                        <badge type="primary" rounded>control</badge>
                                        <badge type="primary" rounded>system</badge>
                                        <badge type="primary" rounded>creative</badge>
                                    </div>
                                    <!-- <base-button tag="a" href="#" type="primary" class="mt-4">
                                        Learn more
                                    </base-button> -->
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="fa fa-cubes" type="success" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-success text-uppercase">Capabilities</h6>
                                    <ul class="list">
                                        <li>Automatic Tuning</li>
                                        <li>Complete Hardware Redundancy</li>
                                        <li>True Hot-Standby: Infinite Fail-Over and Fail-Back Capability</li>
                                    </ul>
                                    <div>
                                        <badge type="success" rounded>hardware</badge>
                                        <badge type="success" rounded>optomatized</badge>
                                        <badge type="success" rounded>success</badge>
                                    </div>
                                    <!-- <base-button tag="a" href="#" type="success" class="mt-4">
                                        Learn more
                                    </base-button> -->
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="fa fa-window-restore" type="info" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-info text-uppercase">Web Launch</h6>
                                    <ul class="list">
                                        <li>MIS/RR Network Integration</li>
                                        <li>Web Based Logs, Reports, Configurable Automated Alarms, and System Health Monitoring</li>
                                    </ul>
                                    <div>
                                        <badge type="info" rounded>report</badge>
                                        <badge type="info" rounded>product</badge>
                                        <badge type="info" rounded>launch</badge>
                                    </div>
                                    <!-- <base-button tag="a" href="#" type="info" class="mt-4">
                                        Learn more
                                    </base-button> -->
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3">3Z’s FlexYard process control system </h2>
                        <p class="lead text-muted">Constructed with reliability, flexibility, and tomorrow’s technology in mind, 3Z ‘s products are built with the most robust, common, and innovative software platforms, frameworks, and languages used today</p>
                    </div>
                </div>
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-md-12 col-lg-12 mb-5 mb-lg-0">
                        <h5>
                            <router-link class="text-red" to="/projectFlexyard">
                            <u>Our FlexYard Projects - CP St. Paul Yard</u>
                        </router-link>
                        </h5>
                    </div>
                    <router-link to="/projectFlexyard" class="col-md-12 col-lg-12 mb-5 mb-lg-10 mt-2">
                        <div class="px-4">
                            <img v-lazy="'img/3z/fy2.png'"
                                 class="rounded index-img img-center img-fluid shadow shadow-lg--hover">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Flexyard QT GUI</span>
                                    <!-- <small class="h6 text-muted">Customizable</small> -->
                                </h5>
                            </div>
                        </div>
                    </router-link>
                    <router-link to="/projectFlexyard" class="col-md-12 col-lg-12 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/3z/fy4.png'"
                                 class="rounded index-img img-center img-fluid shadow shadow-lg--hover">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Flexyard WEB GUI</span>
                                    <!-- <small class="h6 text-muted">Customizable</small> -->
                                </h5>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </section>
        <section class="section section-shaped my-0 mb-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-10 pb-100">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-12">
                        <h2 class="display-2 text-white">Innovative Features</h2>
                        <p class="lead text-white">According to the National Oceanic and Atmospheric Administration,
                            Ted, Scambos, NSIDClead scentist, puts the potentially record low maximum sea ice extent
                            tihs year down to low ice.</p>
                    </div>
                </div>
                <div class="row row-grid mt-5">
                    <div class="col-lg-4">
                        <icon name="fa fa-map-signs" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h4 class="display-4 text-white mt-3">Innovative Features</h4>
                        <p class="text-white mt-3 lead">HumpAnywhere Logic</p>
                        <p class="text-white mt-3 lead">GPS Time Sync</p>
                        <p class="text-white mt-3 lead">FlexVoice–Speech Recognition Control and Audible Voice Alarms</p>
                        <p class="text-white mt-3 lead">Workstation Screen Capture and Video Replay (Under Development)</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="fa fa-line-chart" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h4 class="display-4 text-white mt-3">Benefits of FlexYard</h4>
                        <p class="text-white mt-3 lead">Reliability: No need to reboot with solid-state, robust, industrial hardware with Linux OS.</p>
                        <p class="text-white mt-3 lead">Flexibility: Off the shelf modular hardware,completely database configurable, and FlexDrawworkstation graphic design tool.</p>
                        <p class="text-white mt-3 lead">Accessibility: Remotely access event logs, customizable reports, and monitor system health diagnostics via web browser.</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-atom" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h4 class="display-4 text-white mt-3">Software Platforms</h4>
                        <p class="text-white mt-3 lead">Linux OLE (Oracle) OS: Process Control Servers</p>
                        <p class="text-white mt-3 lead">C++ Programming: Process Control Logic</p>
                        <p class="text-white mt-3 lead">QT App Framework: Linux Workstation GUI</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg bg-secondary">
            <div class="container">
                <div class="row row-grid justify-content-center">
                    <div class="col-lg-12 text-left">
                        <h2 class="display-2">Take Control: Invest in Innovation
                        </h2>
                    </div>
                    <div class="col-lg-8 text-left">
                        <p class="lead"><strong><em>At 3Z,</em></strong> our extensive and diverse experience in railroad has allowed us to understand the technology and operational processes deployed in rail yards throughout the world. More importantly, however, we understand how rail yard technology and operational processes integrate, the existing challenges and deficiencies, and how to incorporate viable solutions to overcome those obstacles.</p>
                    <!-- </div>
                    <div class="col-lg-8 text-left"> -->
                        <hr>
                        <p class="lead"><strong><em>HumpAnywhere</em></strong> is a FlexYard feature that allows humping, switching, or kicking from ANY location, on ANY lead in the yard. Pins can be pulled from the most efficient lead or track for each specific sequence of cars. Are cars only destined for tracks 3, 4, and 5? Do you have a unique lead layout and kick from multiple locations? No need to pull back to the crest. With Hump-Anywhere, just pull back enough to clear the first switch in the next route and the new route you need will line. HumpAnywhere inherently increases yard operating efficiency by reducing the distances of moves, the distances free rolling cuts travel, and the time a user interfaces with the system.</p>
                    </div>
                    <div class="col-lg-4 text-left">
                        <p class="lead"><strong><em>FlexVoice</em></strong> is a newly developed speech recognition and voice alarm application which can be integrated into any FlexYard or FlexTrim system. FlexVoice allows operators to use voice commands to line routes, change modes, add/delete cars from a list, etc. Verbal responses confirm commands after each is requested and after each is executed. With FlexVoice, operators can verbally and securely control the yard system from any fixed or mobile microphone located anywhere in the yard. Eliminate the reliance on Tower or Crest operators to control your yard by adding FlexVoiceto your railroad.</p>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
export default {
  name: "home",
  components: {}
};
</script>
<style scoped>
ul.list {
    padding-left: 1.2rem!important;
}
/* .index-img {
    max-width: 110%;
    width: 110%;
} */
</style>